// extracted by mini-css-extract-plugin
export default {"box":"adUDuw3EV7yHrVTsuAGm","title":"tgbw9FZHOPHZ6ZTTT_OD","subtitle":"PYPoueB5NbOLxldnUA18","proBanner":"vbKrPcBVbx_GPjUYdgRy","proLink":"rSdkK9iRYmAmPHvYtQrq"};